export default __webpack_public_path__ + "static/LogoTop1024-f9fb2150dadc2588bfed28e0de5f194c.png";